/* Shopify section replacements connect/disconnect the element automatically. */
(() => {
  if (customElements.get('cc-collection-carousel')) return;

  class CollectionCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-cc-carousel-track]');
      this.controls = this.querySelector('[data-cc-carousel-controls]');
      this.previous = this.querySelector('[data-cc-carousel-prev]');
      this.next = this.querySelector('[data-cc-carousel-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.controller = new AbortController();
      this.active = false;
      this.frame = null;
      const { signal } = this.controller;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.addEventListener('focusin', () => this.activate(), { signal });
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      window.addEventListener('resize', () => this.scheduleUpdate(), { passive: true, signal });
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('.cc-home-category');
        if (card && this.contains(card)) {
          this.activate();
          card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
        }
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          if (!signal.aborted && entries.some(entry => entry.isIntersecting)) this.activate();
        }, { rootMargin: '400px' });
        this.visibilityObserver.observe(this);
      } else {
        this.activate();
      }
    }

    activate() {
      if (!this.controller || this.active) return;
      this.active = true;
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
      }
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.observer?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.controller = null;
      this.visibilityObserver = null;
      this.observer = null;
      this.active = false;
      this.frame = null;
    }

    scheduleUpdate() {
      if (!this.active || this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.min(max, Math.max(0, Math.abs(this.track.scrollLeft)));
      this.controls.hidden = max < 2;
      this.previous.disabled = position < 2;
      this.next.disabled = max - position < 2;
    }

    move(direction) {
      this.activate();
      const cards = this.track.querySelectorAll('.cc-home-category');
      if (!cards.length) return;
      const first = cards[0].getBoundingClientRect();
      const distance = cards.length > 1 ? Math.abs(cards[1].getBoundingClientRect().left - first.left) : first.width;
      const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * distance * rtl, behavior: reduceMotion ? 'instant' : 'smooth' });
    }
  }

  customElements.define('cc-collection-carousel', CollectionCarousel);
})();
